import { combineSearchParams } from '../combineSearchParams/combineSearchParams';

//This util is used to take search params before url hash and move them after it to make it achievable for the angular router
export const collectSearchParams = (basePath: string) => {
  const hashPortion = window.location.hash;
  const searchParamsAfterHash = hashPortion.substring(hashPortion.indexOf('?'));

  window.location.replace(
    combineSearchParams(basePath, [window.location.search, searchParamsAfterHash]),
  );
};
